<template>
  <v-app>
    <v-app-bar color="cyan darken-2" dark fixed app>
      <img class="svg" src="./assets/om-logo.svg" height="80%" style="padding-left:2%;" />
      <v-spacer />
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn v-for="item in menu" :key="item.id" @click="scrollTo(item.id)" text>{{
          item.title
        }}</v-btn>
      </v-toolbar-items>
      <v-toolbar-items class="hidden-md-and-up">
        <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      </v-toolbar-items>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" temporary app class="grey lighten-4">
      <v-list nav dense>
        <v-list-item-group active-class="white--text blue-grey lighten-2">
          <v-list-item v-for="item in menu" :key="item.id" @click="scrollTo(item.id)">
            <v-list-item-title class="text-left">{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

  <v-main>

    <v-container style="width: 60%; padding-top: 7%;">
      <h1 class="h1">
        Somos una <span class="cyan--text text--darken-3">empresa consultora</span> especializada en el mercado eléctrico, fundada en 2016.
      </h1>
    </v-container>

    <CoverLarge class="hidden-sm-and-down" />
    <CoverSmall class="hidden-md-and-up" />

    <v-container style="padding-top: 7%;" ref="who">
      <div
        style="width: 10%; height: 1px;"
        class="centered cyan darken-3"
        single-line
      />
      <div class="hidden-md-and-up" style="padding: 5%;" />
      <h5 class="banner">
        QUIÉNES SOMOS
      </h5>
    </v-container>

    <Who />

    <v-container style="padding-top: 7%;" ref="work">
      <div style="width: 10%; height: 1px" class="centered cyan darken-3" single-line/>
      <div class="hidden-md-and-up" style="padding: 5%;" />
      <h5 class="banner">
        QUÉ HACEMOS
      </h5>
    </v-container>

    <WorkLarge class="hidden-sm-and-down" />
    <WorkSmall class="hidden-md-and-up" />

    <v-container style="padding-top: 7%;" ref="clients">
      <div style="width: 10%; height: 1px" class="centered cyan darken-3" single-line/>
      <div class="hidden-md-and-up" style="padding: 5%;" />
      <h5 class="banner">
        NUESTROS CLIENTES
      </h5>
    </v-container>

    <v-container style="width: 90%; padding-top: 7%;">
      <v-slide-group
        center-active
        show-arrows
      >
        <v-slide-item>
          <v-card class="mx-auto" height="80" width="300" :elevation="0">
            <v-img :src="require('./assets/clients/logo-BHP.png')" height="100%" contain/>
          </v-card>
        </v-slide-item>
        <v-slide-item>
          <v-card class="mx-auto" height="80" width="400" :elevation="0">
            <v-img :src="require('./assets/clients/logo-CGE-01.png')" height="100%" contain/>
          </v-card>
        </v-slide-item>
        <v-slide-item>
          <v-card class="mx-auto" height="80" width="400" :elevation="0">
            <v-img :src="require('./assets/clients/logo-eLlaima.jpg')" height="100%" contain/>
          </v-card>
        </v-slide-item>
        <v-slide-item>
          <v-card class="mx-auto" height="80" width="400" :elevation="0">
            <v-img :src="require('./assets/clients/logo-ENAP.jpg')" height="100%" contain/>
          </v-card>
        </v-slide-item>
        <v-slide-item>
          <v-card class="mx-auto" height="100" width="200" :elevation="0">
            <v-img :src="require('./assets/clients/logo-MOP.png')" height="100%" contain/>
          </v-card>
        </v-slide-item>
        <v-slide-item>
          <v-card class="mx-auto" height="80" width="400" :elevation="0">
            <v-img :src="require('./assets/clients/logo-SWO.png')" height="100%" contain/>
          </v-card>
        </v-slide-item>
      </v-slide-group>
    </v-container>

    <ClientsLarge class="d-none d-sm-flex flex-column" />
    <ClientsXSmall class="d-flex d-sm-none flex-column" />

    <v-container style="padding-top: 7%;" ref="contact">
      <div style="width: 10%; height: 1px" class="centered cyan darken-3" single-line/>
      <div class="hidden-md-and-up" style="padding: 5%;" />
      <h5 class="banner">
        CONTACTO
      </h5>
    </v-container>

    <ContactLarge class="d-none d-sm-flex flex-column" />
    <ContactXSmall class="d-flex d-sm-none flex-column" />

  </v-main>

  <v-footer height="auto" color="cyan darken-3" dark>
    <v-flex color="cyan darken-3" dark py-3 text-xs-center white--text xs12>
      &copy; 2023 — OptimalMarkets SpA
    </v-flex>
  </v-footer>

</v-app>
</template>

<script>
import ClientsLarge from './components/ClientsLarge.vue'
import ClientsXSmall from './components/ClientsXSmall.vue'
import ContactLarge from './components/ContactLarge.vue'
import ContactXSmall from './components/ContactXSmall.vue'
import CoverLarge from './components/CoverLarge.vue'
import CoverSmall from './components/CoverSmall.vue'
import Who from './components/Who.vue'
import WorkLarge from './components/WorkLarge.vue'
import WorkSmall from './components/WorkSmall.vue'

export default {
  name: 'app',
  data () {
    return {
      drawer: false,
      menu: [
        { id: "who", icon: "mdi-account-group", title: "Quienes Somos" },
        { id: "work", icon: "mdi-account-question", title: "Que Hacemos" },
        { id: "clients", icon: "mdi-domain", title: "Nuestros Clientes" },
        { id: "contact", icon: "mdi-phone", title: "Contacto" },
      ],
      items: [
        { src: "./assets/slide-01.jpg" },
        { src: "./assets/slide-02.jpg" },
        { src: "./assets/slide-03.jpg" },
      ],
    }
  },
  components: {
    ClientsLarge,
    ClientsXSmall,
    ContactLarge,
    ContactXSmall,
    CoverLarge,
    CoverSmall,
    Who,
    WorkLarge,
    WorkSmall,
  },
  methods: {
    scrollTo(id) {
      this.$refs[id].scrollIntoView({ behavior: "smooth" });
    }
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.h1 {
  font-weight: 500;
  font-size: 2.2rem;
  color: #161c2d;
  line-height: 2.6rem;
}

.body {
  color: #161c2d;
}

.banner {
  font-weight: 300;
  font-size: 2rem;
  color: #00838f;
}

h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.container {
  position: relative;
  text-align: center;
  width: 80%;
}

/* Centered text */
.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.label {
  color: #bdbdbd;
  margin-bottom: 10px;
}

.text-color {
  color: #00838f;
}
</style>



// WEBPACK FOOTER //
// src/App.vue